import { useState } from 'react';

const useDrawerState = () => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return [open, handleClick, handleClose];
};

export default useDrawerState;
